import { Component, Input } from '@angular/core';
import { Constants } from '../../constants';

@Component({
  selector: 'app-logo',
  standalone: true,
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss'
})
export class LogoComponent {
  @Input() size?: string;
  @Input() showTitle = true;
  @Input() customTitleClass?: string;

  public readonly systemName = Constants.SystemName;
}
